import axios from "axios";
import { toast } from "react-toastify";
import authHeader from "./auth-header";

export const fetchReconOrders = (filters = {}) => {
  const query_string = new URLSearchParams(filters).toString();
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/orderrecon/orders?${query_string}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchCaseDetails = (orderIds) => {
  if (!orderIds || orderIds.length === 0) return Promise.resolve([]);
  const query_string = new URLSearchParams({ orderIds: orderIds.join(",") }).toString();
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/orderrecon/case-details?${query_string}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const toggleCaseRecon = (data) => {
  return axios
    .put(`${process.env.REACT_APP_BASE_URL}/orderrecon/toggle-case`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchItemDetails = (filters = {}) => {
  const query_string = new URLSearchParams(filters).toString();
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/orderrecon/item-details?${query_string}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const updateItemRecon = (data) => {
  return axios
    .put(`${process.env.REACT_APP_BASE_URL}/orderrecon/update-items`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};
